import React from 'react';
import { SlideImage } from '.';
import { Header, Step, SlideIcon } from '../styles';
import { useTranslation } from 'react-i18next';
import { useSlideData } from '@context/slide-data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getSlideTranslationKey } from '@utils/profileUtils';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type GridStepWithImageProps = {
    handleClick: (text: string) => void,
    currentSteps: string[],
    step: number | null,
    name: string,
    icon: IconProp | string
}

export const GridStepWithImage = ({ handleClick, currentSteps, step, name, icon }: GridStepWithImageProps) => {
    const { t } = useTranslation();
    const { data } = useSlideData();
    const slideKey = getSlideTranslationKey(data.name);
    const text = t(`${slideKey}.step_${step}.text`);

    return (
        <Step  
            data-testid={text}
            width={step === 5 ? '100%' : '50%'}
            onClick={() => handleClick(text)}
            selected={currentSteps.includes(text)}>
                {
                    typeof icon !== 'string' ? 
                        <SlideIcon as='div'>
                            <FontAwesomeIcon icon={icon}/>
                        </SlideIcon> : <SlideImage alt={text} name={name}/>
                }
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Header fontSize={'15px'} >
                        {t(`${slideKey}.step_${step}.title`)}
                    </Header>
                    <span>{text}</span>
                </div>
        </Step>
    );
};

export default GridStepWithImage;
